import React from "react";
import moment from "moment";
import PPMobileCardView from "../../../components/PPMobileCardView";

const Mobile = ({ data, onDelete, onEdit }) => {
  const rows = [
    ...(Array.isArray(data.stockAdjustments)
      ? data.stockAdjustments.map((item) => ({
          label: item.materialName || item.materialTypeName || "Material",
          value: item.quantity,
        }))
      : []),
    data.materialTypeName !== undefined && {
      label: "Material Type",
      value: data.materialTypeName,
    },
    data.materialName !== undefined && {
      label: "Material Name",
      value: data.materialName,
    },
    data.closingStock !== undefined && {
      label: "Closing Stock",
      value: data.closingStock,
    },
  ].filter(Boolean);

  const menuItems = [
    { label: "Edit", onClick: onEdit },
    { label: "Delete", onClick: onDelete },
  ];

  return (
    <PPMobileCardView
      title={moment(data.adjustmentDate || data.date).format("DD-MM-YYYY")}
      rows={rows}
      menuItems={menuItems}
    />
  );
};

export default Mobile;
